/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { SubmissionComponentDataRequest } from './submissionComponentDataRequest';


export interface SubmissionDataRequest { 
    /**
     * The submission's name
     */
    name: string;
    /**
     * The submission's nosologico
     */
    nosologico: string;
    /**
     * The submission's schemaData
     */
    schemaData: string;
    /**
     * The submission's componets data list
     */
    submissionComponents: Array<SubmissionComponentDataRequest>;
    /**
     * The submission's user
     */
    user: string;
    /**
     * The patient's uuid
     */
    uuidPatient: string;
    /**
     * The submission's uuidTemplate
     */
    uuidTemplate: string;
}
